import { render, staticRenderFns } from "./combine-tab-list.vue?vue&type=template&id=45b37326"
import script from "./combine-tab-list.vue?vue&type=script&lang=js"
export * from "./combine-tab-list.vue?vue&type=script&lang=js"
import style0 from "./combine-tab-list.vue?vue&type=style&index=0&id=45b37326&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports